import { ref } from "vue";
import { useRutasStore } from "./useRutasStore";
import { useNominatim } from "@/composables/useNominatim";
import { notify } from "@/composables/useNotificationBus";

const makerTitles = {
  home: "Zona Poblada",
}

const labels = {
  houses: {
    "1": "1 Casa",
    "2-4": "2 a 4 Casas",
    "5-10": "5 a 10 Casas",
    ">10": "Más de 10 Casas",
  },
  vehicleType: {
    "car": "Cualquier Vehiculo",
    "truck": "Vehiculos Altos",
    "4x4": "Solo 4x4",
    "motorcycle": "Solo Motos",
    "bicycle": "Solo Bicicletas",
    "walking": "Solo Caminando",
  },
  security: {
    // tranquilo, normal, inseguro, peligroso, muy peligroso
    "low": "Zona Tranquila",
    "normal": "Precauciones normales",
    "unsafe": "Zona Insegura",
    "dangerous": "Zona Peligrosa",
    "very-dangerous": "Zona Muy Peligrosa",
  }
}

export const useRutas = () => {
  const rutasStore = useRutasStore();
  const { geocodeAddress } = useNominatim();
  const address = ref("");
  const geocodeFinder = ref(null);
  let map = null;
  let m = null;
  const pointType = ref("route");
  const activePoint = ref(null);
  const activeMap = ref(null);
  let activeLayer = [];
  let temporalMarker = null;
  // let lastPointMarker = null;
  let routePointMarkers = [];
  let routeMarkers = [];
  let zoneMarkers = [];
  let dontClear = false;

  const makerIcon = {
    home: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"/></svg>`,
    route: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>`,
  }

  const clearActiveLayer = () => {
    if (activeLayer.length > 0) {
      activeLayer.forEach(layer => {
        map().removeLayer(layer);
      });
      activeLayer = [];
    }
  }


  const clearZoneMarkers = () => {
   
    if (zoneMarkers.length > 0) {
      zoneMarkers.forEach(marker => {
        map().removeLayer(marker);
      });
      zoneMarkers = [];
    }
  }

  const clearMap = async () => {
    activePoint.value = null;
    if (temporalMarker) {
      map().removeLayer(temporalMarker);
      temporalMarker = null;
    }
    await clearActiveLayer();
    if (routePointMarkers.length > 0) {
      routePointMarkers.forEach(marker => {
        map().removeLayer(marker);
      });
      routePointMarkers = [];
    }
    await clearZoneMarkers();
    if (routeMarkers.length > 0) {
      routeMarkers.forEach(marker => {
        map().removeLayer(marker);
      });
      routeMarkers = [];
    }

    
  }

  const createRoute = () => {
    clearMap();
    pointType.value = "route";
    activeMap.value = {
      center: [0, 0],
      zoom: 14,
      route: [],
      points: [],
      vehicleQty: 3,
      vehiclePeopleQty: 2,
      notes: "",
    }
  }

  const onMapReady = (mValue) => {
    console.log("onMapReady", mValue)
    map = mValue.map;
    m = mValue.m;
    setMapEvents();

  }
  const setMapEvents = () => {
    console.log("setMapEvents")
    // zoomstart
    map().on('zoomstart', function (e) {
      console.log("zoomstart", e)
    });

    // set center 
    map().on('moveend', function (e) {
      if (!activeMap.value) return;
      console.log("moveend", e)
      
      activeMap.value.center = m().getCenter();
    });
  }

  // agrega un punto a la ruta activa
  const addPointToActiveRoute = (data) => {
    if (!activeMap.value) return;
    if (pointType.value !== "route") {
      console.log("No es un punto de ruta")
      setActivePoint(data);
      return
    };
    console.log("addPointToActiveRoute", data)
    const points = [data.latlng.lat, data.latlng.lng]
    if (data) activeMap.value.route = [
      ...activeMap.value.route,
      points
    ]
    drawRoute(activeMap.value.route)
  };

  const saveRoute = () => {
    console.log("saveRoute", activeMap.value, rutasStore.list)
    let isNew = false;
    if (!activeMap.value.id) {
      isNew = true;
      activeMap.value.id = Date.now();
    }
    let newList = []
    if (!isNew) {
      newList = rutasStore.list.map(item => {
        if (item.id === activeMap.value.id) {
          return {
            ...activeMap.value
          }
        }
        return item
      });
    } else {
      newList = [
        ...rutasStore.list,
        {
          ...activeMap.value
        }
      ]
    }

    rutasStore.setRutas(newList);
    activeMap.value = null;
    clearMap();
  }

  const drawRoute = async (route, events = true) => {
    if (!dontClear) {
      await clearActiveLayer();
    }

    console.log("drawRoute", m().sectorOption)

    const activeLayerItem = m().L.polyline(route, m().sectorOption).addTo(map());
    activeLayer.push(activeLayerItem);

    // add marker for last point
    // if (lastPointMarker) map().removeLayer(lastPointMarker);
    if (routePointMarkers.length > 0 && !dontClear) {
      routePointMarkers.forEach(marker => {
        map().removeLayer(marker);
      });
      routePointMarkers = [];
    }
    // const lastPoint = route[route.length - 1];
    // console.log(" add marker for last point", lastPoint)

    if (dontClear) return
    const markerIcon = L.icon({
      iconUrl: `marker-icon.png`,
      iconAnchor: [12, 41],
      iconSize: [25, 41],
    });
    for (let i = 0; i < route.length; i++) {
      const point = route[i];
      const marker = m().L.marker({
        lat: point[0],
        lng: point[1]
      }, {
        icon: markerIcon,
        draggable: true
      }).addTo(map())
      marker.on('click', function (e) {
        // console.log("marker", e)
        // removePoint(e.latlng)
      });
      marker.on('dblclick', function (e) {
        // console.log("dblclick", e)
        duplicatePoint(e.latlng)
      })
      marker.on('contextmenu', function (e) {
        // e.preventDefault();
        // console.log("contextmenu", e)

        removePoint(e.latlng)
        // setActivePoint(e)
      });
      marker.on('dragend', function (e) {
        // console.log("dragend", e.target.getLatLng())
        movePoint(e.target.getLatLng(), i)
      });
      routePointMarkers.push(marker);
    }
  }

  const duplicatePoint = (point) => {
    // look for the index of the point
    const index = activeMap.value.route.findIndex(p => p[0] === point.lat && p[1] === point.lng);
    // create a new point with the same coordinates
    const newPoint = [point.lat, point.lng];
    // insert the new point after the current point
    activeMap.value.route.splice(index + 1, 0, newPoint);
    drawRoute(activeMap.value.route)
  }

  const movePoint = (point, index) => {
    console.log("movePoint", point, index)
    activeMap.value.route[index] = [point.lat, point.lng];
    drawRoute(activeMap.value.route)
  }

  const removePoint = (point) => {
    console.log("removePoint", point)
    activeMap.value.route = activeMap.value.route.filter(p => p[0] !== point.lat && p[1] !== point.lng);
    drawRoute(activeMap.value.route)
  }

  const setActivePoint = async (data) => {
    await clearZoneMarkers();
    if (temporalMarker) map().removeLayer(temporalMarker);
    activePoint.value = data.latlng;
    console.log("activePoint >>>", data, activePoint.value)
    const type = data?.target ? pointType.value : data.type;
    console.log("type >>>", type)
    let pointParams = {
      ...data,
      label: makerTitles[type],
    }
    addIconToMap(pointParams, (point) => {
      console.log("onDrag", point)
      activePoint.value = point;  
    });
  }

  const addIconToMap = (data, onDrag) => {
    console.log("addIconToMap", data)
    
    // const divIcon = m().L.divIcon({
    //   className: 'manzana-marker ',
    //   iconSize: null,
    //   html: `<div class="icon manzana-marker-center" style="font-size: 1em;">${data.label}</div><div class="arrow" />`
    // });
    const markerIcon = L.icon({
      iconUrl: `marker-icon.png`,
      iconAnchor: [12, 41],
      iconSize: [25, 41],
    });

    const draggable = onDrag ? true : false;
    
    temporalMarker = m().L.marker(data.latlng, { icon: markerIcon, draggable }).addTo(map()).bindPopup(data.label);

    temporalMarker.on('dragend', function (e) {
      onDrag(e.target.getLatLng());
    });
  }

  // setea el lugar en el mapa activo y centra el mapa en ese lugar
  const placeFinder = (place) => {
    const center = place ? [place.lat, place.lon] : [0, 0]
    geocodeFinder.value = place
    activeMap.value.center = center
    console.log("map", center, map().m)
    map().flyTo(center, 16);
  }

  // busca coordenadas de una dirección
  async function geocode() {
    try {
      const data = await geocodeAddress(address.value)
      if (!data || data.length == 0) {
        console.log("No se encontraron resultados")
        placeFinder(null)
        return null
      }
      placeFinder(data[0])
      return data[0]
    }
    catch (e) {
      console.log("Error:", e);
      placeFinder(null)
      return null
    }
  }

  const showRouteMarker = (point, htmlParams = {}) => {
    console.log("showRouteMarker", point, htmlParams)
    const label = htmlParams?.label || makerTitles[point.type];
    const icon = htmlParams?.icon || makerIcon[point.type];
    const htmlclass = htmlParams?.class || "";

    let html = `<div class="${htmlclass}" style="font-size: 1em; background: rgba(255, 255, 255, 0.5); width: 100px; text-align: center; padding-top: 5px;">
    <div class="header" style="display: flex; gap: 5px; padding: 5px; justify-content: center;">`

    // header
    // index: a number inside a circle
    if (htmlParams.index) html += `<div style="width: 20px; background: #fff; border-radius: 50%; padding: 2px; font-size: 0.8em; color: #007aff; border: 1px solid #007aff; text-align: center; width: 20px; height: 20px;">${htmlParams.index}</div>`
    if (icon) html += `<div style="width: 20px">${icon}</div>`
    
    html += `</div>`
    // body
    html += `<div class="body" style="padding: 0 5px 5px;">`
    if (point.houses) html += `<div>${labels.houses[point.houses]}</div>`
    if (point.vehicleType) html += `<div class="noprint">${labels.vehicleType[point.vehicleType]}</div>`
    if (point.security) html += `<div class="noprint">${labels.security[point.security]}</div>`

    if (htmlParams.label) html += `<div class="lable">${htmlParams.label}</div>`
    html += `</div><div class="arrow" />`

    console.log("htmlParams", htmlParams)

    const divIcon = m().L.divIcon({
      className: 'manzana-marker ',
      iconSize: [15,15],
      iconAnchor: [7, 7],


      html: htmlParams.index ?
      `<div class="icon manzana-marker-center" 
      style="font-size: 1.2em; color: white; margin-top: -15px; padding: 2px 5px; background: #000; border: red; border-radius: 50%;">
      ${htmlParams.index}</div>` : html
    });
    const marker = m().L.marker(point.latlng, {
      icon: divIcon,
      draggable: false
    }).addTo(map()).bindPopup(html);
    zoneMarkers.push(marker);
  }

  const showRouteMarkers = (pointsDetail) => {
    if (routeMarkers.length > 0 && !dontClear) {
      routeMarkers.forEach(marker => {
        map().removeLayer(marker);
      });
    }

    const points = pointsDetail || activeMap.value.points;
    if (points.length === 0) return
    for (let i = 0; i < points.length; i++) {
      const point = points[i];

      showRouteMarker(point, {
        index: i + 1
      });
    }
  }

  const refreshActivePoint = (point) => {
    if (!point) {
      if (temporalMarker) map().removeLayer(temporalMarker);
      activePoint.value = null;
      showRouteMarkers();
      return
    }
    setActivePoint(point);
  }

  const editRoute = async (route) => {
    document.title = route.name;
    map().flyTo(route.center, 16);
    await clearMap();
    pointType.value = "route";
    activeMap.value = {
      ...route
    }
    console.log("editRoute", route)
    // move the map to the center
    await drawRouteFull(route)
    // showRouteMarkers();
  }

  const noSaveRoute = () => {
    activeMap.value = null;
    clearMap();
  }

  const drawRouteFull = async (route) => {
    await showRouteMarkers(route.points)
    await drawRoute(route.route, false)
    await addRouteName(route)
  }

  const showRoutes = async () => {
    document.title = "Rutas";
    dontClear = true;
    for (let i = 0; i < rutasStore.list.length; i++) {
      const route = rutasStore.list[i];
      await drawRouteFull(route);
      
    }
    dontClear = false;
  }

  const addRouteName = async (route) => {
    const point = route.route[0];
    if (!point) {
      notify.warn("Sin punto de inicio", "No se encontró el punto de inicio de la ruta.")
      return
    }
    const latlng = {
      lat: point[0],
      lng: point[1]
    }
    showRouteMarker({
      latlng,
    }, {
      class: 'noprint',
      icon: makerIcon.route,
      label: route.name
    });
  }

  const deleteRoute = async (route) => {
    const newList = rutasStore.list.filter(item => item.id !== route.id)
    rutasStore.setRutas(newList);
    activeMap.value = null;
    clearMap();

  }


  return {
    rutasStore,
    map,
    address,
    activeMap,
    activePoint,
    createRoute,
    editRoute,
    geocode,
    pointType,
    saveRoute,
    noSaveRoute,
    deleteRoute,
    showRoutes,
    refreshActivePoint,
    addPointToActiveRoute,
    onMapReady,
  }
}